import { render, staticRenderFns } from "./OverlayPartial.vue?vue&type=template&id=6fbf0946"
import script from "../../js/components/partials/Overlay.js?vue&type=script&lang=js&external"
export * from "../../js/components/partials/Overlay.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports